import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { CategoryProductsService } from '@shared/service';
import { ProductsShowcaseComponent } from '../../../shared/components/products-showcase/products-showcase.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-similar-style',
    templateUrl: './similar-style.component.html',
    styleUrls: ['./similar-style.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProductsShowcaseComponent, AsyncPipe],
})
export class SimilarStyleComponent implements OnInit {
    private categoryProductsService = inject(CategoryProductsService);

    products$ = this.categoryProductsService.productsByCategory$;
    category$ = this.categoryProductsService.category$;

    ngOnInit(): void {
        this.categoryProductsService.dispatch();
    }
}
